// Helpers de fecha seguros en todos los navegadores (Safari/WebKit incluido).
//
// Fecha de creación: 2026-09-02
// Autor: IA (Claude)

// Devuelve yyyy-MM-dd en hora LOCAL (sin desfase de UTC).
export const formatearFechaLocal = (fecha) => {
    const d = fecha instanceof Date ? fecha : new Date(fecha);
    if (isNaN(d.getTime())) return "";
    const anio = d.getFullYear();
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const dia = String(d.getDate()).padStart(2, "0");
    return `${anio}-${mes}-${dia}`;
};

// Primer día del mes de la fecha dada, como yyyy-MM-dd local.
export const primerDiaDelMes = (fecha = new Date()) =>
    formatearFechaLocal(new Date(fecha.getFullYear(), fecha.getMonth(), 1));

// Último día del mes de la fecha dada, como yyyy-MM-dd local.
export const ultimoDiaDelMes = (fecha = new Date()) =>
    formatearFechaLocal(new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0));

// Fecha de hoy como yyyy-MM-dd local.
export const hoyLocal = () => formatearFechaLocal(new Date());

// Convierte fecha del backend en formato MM/dd/yyyy [HH:mm:ss] a yyyy-MM-dd.
export const fechaMMDDaInput = (fecha) => {
    if (!fecha) return "";
    const [parteFecha] = String(fecha).trim().split(" ");
    if (/^\d{4}-\d{2}-\d{2}/.test(parteFecha)) return parteFecha.slice(0, 10);
    const [mes, dia, anio] = parteFecha.split("/");
    if (!dia || !mes || !anio) return "";
    return `${anio}-${String(mes).padStart(2, "0")}-${String(dia).padStart(2, "0")}`;
};

// Convierte fecha del backend en formato dd/MM/yyyy [HH:mm:ss] a yyyy-MM-dd.
export const fechaDDMMaInput = (fecha) => {
    if (!fecha) return "";
    const [parteFecha] = String(fecha).trim().split(" ");
    if (/^\d{4}-\d{2}-\d{2}/.test(parteFecha)) return parteFecha.slice(0, 10);
    const [dia, mes, anio] = parteFecha.split("/");
    if (!dia || !mes || !anio) return "";
    return `${anio}-${String(mes).padStart(2, "0")}-${String(dia).padStart(2, "0")}`;
};

// Convierte yyyy-MM-dd a un Date local (evita el parseo UTC del constructor).
export const inputAFechaLocal = (valor) => {
    if (!valor) return null;
    const [anio, mes, dia] = String(valor).slice(0, 10).split("-").map(Number);
    if (!anio || !mes || !dia) return null;
    return new Date(anio, mes - 1, dia);
};

// Convierte fecha ISO del backend (yyyy-MM-ddTHH:mm:ss) a dd/MM/yyyy.
// Devuelve "" si viene null, inválida o es la fecha mínima de .NET (0001-01-01).
// Agregado: 2026-09-15 — IA (Claude)
export const isoADDMMYYYY = (fecha) => {
    if (!fecha) return "";
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(fecha));
    if (!match) return "";
    const [, anio, mes, dia] = match;
    if (Number(anio) <= 1) return "";
    return `${dia}/${mes}/${anio}`;
};
